import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { Form, Button } from 'react-bootstrap';
import { MobilePhoneField } from '../components/MobilePhoneField';
import { StringField } from '../components/StringField';
import { PageError } from '../components/PageError';
import { validateInput, dictonary } from '../utils';
export var SignInByPhone = /*#__PURE__*/function (_React$Component) {
  _inherits(SignInByPhone, _React$Component);

  var _super = _createSuper(SignInByPhone);

  function SignInByPhone(props) {
    var _this;

    _classCallCheck(this, SignInByPhone);

    _this = _super.call(this, props);

    _this.onSubmit = function (values) {
      var prepareValues = _this.prepereValues(values);

      var isPhoneSent = _this.state.isPhoneSent;
      var _this$props = _this.props,
          history = _this$props.history,
          onSubmitPhone = _this$props.onSubmitPhone,
          onSubmitCode = _this$props.onSubmitCode,
          path = _this$props.path;

      if (!isPhoneSent) {
        return onSubmitPhone(prepareValues).then(function () {
          _this.setState({
            isPhoneSent: true
          });
        }).catch(function (err) {
          return err;
        });
      }

      return onSubmitCode(prepareValues).then(function () {
        history.push(path.linkSubmit);
      }).catch(function (err) {
        return err;
      });
    };

    _this.onValidate = function (values) {
      var isPhoneSent = _this.state.isPhoneSent;
      var checkFields = ['phone'];

      if (isPhoneSent) {
        checkFields.push('code');
      }

      return validateInput(values, checkFields);
    };

    _this.prepereValues = function (values) {
      var phone = values.phone,
          rest = __rest(values, ["phone"]);

      return Object.assign(Object.assign({}, rest), {
        phone: '+7' + (phone === null || phone === void 0 ? void 0 : phone.replace(/\D/g, ''))
      });
    };

    _this.state = {
      isPhoneSent: false
    };
    props.setTitle(dictonary.title.login);
    return _this;
  }

  _createClass(SignInByPhone, [{
    key: "render",
    value: function render() {
      var isPhoneSent = this.state.isPhoneSent;
      var dictionary = this.props.dictionary;
      var _dictonary$button = dictonary.button,
          getToken = _dictonary$button.getToken,
          sendPhone = _dictonary$button.sendPhone,
          _dictonary$formContro = dictonary.formControl,
          phone = _dictonary$formContro.phone,
          code = _dictonary$formContro.code;
      return React.createElement(FinalForm, {
        onSubmit: this.onSubmit,
        validateOnBlur: true,
        validate: this.onValidate,
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit,
              form = _ref.form,
              submitErrors = _ref.submitErrors,
              active = _ref.active;
          return React.createElement("form", {
            onSubmit: handleSubmit
          }, React.createElement("div", {
            className: 'authentication-wrapper authentication-1 px-4'
          }, React.createElement("div", {
            className: 'authentication-inner py-5'
          }, React.createElement(Form.Group, null, React.createElement(MobilePhoneField, {
            name: 'phone',
            isRequired: true,
            placeholder: phone.placeholder,
            label: {
              label: phone.label
            }
          }), React.createElement(StringField, {
            isVisible: isPhoneSent,
            name: 'code',
            isRequired: isPhoneSent,
            placeholder: code.placeholder,
            label: {
              label: code.label
            }
          })), React.createElement("div", {
            className: 'd-flex justify-content-center m-0'
          }, React.createElement(Button, {
            onClick: form.submit
          }, isPhoneSent ? getToken : sendPhone)), !active && React.createElement(PageError, {
            err: submitErrors,
            dictionary: dictionary
          }))));
        }
      });
    }
  }]);

  return SignInByPhone;
}(React.Component);